<template>
  <div>
    <div class="black_panel_cla">
      <div class="header-button-bar">
        <zk-tool-bar @add="addConfigType"></zk-tool-bar>
      </div>
      <el-table :data="tableData">
        <el-table-column label="#"
                         type="index"></el-table-column>
        <el-table-column :label="this.$t('configType.name')"
                         prop="name"></el-table-column>
        <el-table-column label="Sid"
                         prop="sid"></el-table-column>
        <el-table-column :label="this.$t('configType.toPush')"
                         prop="status">
          <template slot-scope="scope">
            <span v-if="scope.row.status">{{ $t('configType.turnOn') }}</span>
            <span v-else>{{ $t('configType.turnOff') }}</span>
          </template>
        </el-table-column>
        <el-table-column label="i18nKey"
                         prop="i18nKey"></el-table-column>
        <el-table-column :label="this.$t('configType.desc')"
                         prop="description"></el-table-column>
        <el-table-column :label="this.$t('configType.operate')">
          <template slot-scope="scope">
            <ZkButtonGroup :isGroup="true"
                           :event="!scope.row.isEdit ? pushEvents : editEvents"
                           size="mini"
                           :params="scope.row"
                           :showText="true"
                           groupName="config-operate"
                           @deleteConfig="deleteConfig"
                           @update="update"
                           @save="save"
                           @cancel="cancel"
                           :onlyShowText="true"></ZkButtonGroup>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination-margin-top">
        <el-pagination background
                       @size-change="changePageSize"
                       @current-change="changePage"
                       :current-page="pager.curPage"
                       :page-size="pager.pageSize"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pager.total"
                       :pager-count="5"></el-pagination>
      </div>
    </div>

    <el-dialog :title="title"
               :visible.sync="dialogVisible"
               width="45%"
               @close="handleClose">
      <el-form :model="configForm"
               :rules="rules"
               label-position="right"
               label-width="120px"
               ref="ruleForm"
               class="demo-ruleForm">
        <el-form-item :label="this.$t('configType.name')"
                      prop="name">
          <el-row>
            <el-col :span="22">
              <el-input v-model.trim="configForm.name"></el-input>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item :label="$t('configType.pushType')"
                      prop="checkList">
          <el-row>
            <el-col :span="22">
              <el-checkbox-group v-model="configForm.checkList"
                                 @change="handlePushTypeChange">
                <template v-for="item in pushTypeList">
                  <el-checkbox :label="item.value"
                               :key="item.value">{{
                    item.name
                  }}</el-checkbox>
                </template>
              </el-checkbox-group>
            </el-col>
          </el-row>
        </el-form-item>

        <el-form-item label="Sid"
                      prop="sid">
          <el-row>
            <el-col :span="22">
              <el-input v-model.trim="configForm.sid"></el-input>
            </el-col>
            <el-col :span="2"
                    align="center">
              <el-popover placement="right"
                          width="282"
                          trigger="hover">
                <div>{{ $t('configType.only') }}</div>
                <i class="el-icon-question tips_cla"
                   slot="reference"></i>
              </el-popover>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item :label="this.$t('configType.queue')"
                      prop="queueId">
          <el-row>
            <el-col :span="22">
              <el-select v-model.trim="configForm.queueId"
                         :placeholder="this.$t('common.select')"
                         style="width:100%">
                <el-option v-for="item in eventType"
                           :key="item.id"
                           :label="item.name"
                           :value="item.id"></el-option>
              </el-select>
            </el-col>
          </el-row>
        </el-form-item>

        <el-form-item label="i18nKey"
                      prop="i18nKey">
          <el-row>
            <el-col :span="22">
              <el-input v-model.trim="configForm.i18nKey"></el-input>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item :label="this.$t('configType.sort')"
                      prop="sort">
          <el-row>
            <el-col :span="22">
              <el-input v-model.trim="configForm.sort"></el-input>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item :label="this.$t('configType.desc')"
                      prop="description">
          <el-row>
            <el-col :span="22">
              <el-input type="textarea"
                        :placeholder="this.$t('common.enterValue')"
                        show-word-limit
                        v-model.trim="configForm.description"></el-input>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item label-width="130px"
                      :label="this.$t('configType.toPush')"
                      prop="status">
          <el-switch v-model="configForm.status"
                     active-color="#13ce66"></el-switch>
        </el-form-item>
      </el-form>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="handleClose">{{ $t('common.cancel') }}</el-button>
        <el-button type="primary"
                   @click="sumbitConfig">
          {{ $t('common.confirm') }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getQueueLists,
  addConfig,
  getConfigList,
  updateConfigType,
  deleteConfig
} from '@/services/appManagerApi.js'
import { getByType } from '@/cdpBase/services/dictionary.js'
export default {
  data () {
    let sortRule = (rule, value, callback) => {
      if (!value) {
        callback()
      }
      if (!/^[0-9]*$/.test(value)) {
        return callback(new Error(this.$t('resource.intRequire')))
      } else {
        callback()
      }
    }
    return {
      tableData: [],
      pushEvents: ['update', 'deleteConfig'],
      editEvents: ['save', 'cancel'],
      pushTypeList: [],
      isEdit: false,
      configForm: {
        name: '',
        description: '',
        sid: '',
        status: true,
        sort: '',
        i18nKey: '',
        queueId: '',
        checkList: []
      },
      rules: {
        name: [
          {
            required: true,
            message: this.$t('configType.reqName'),
            trigger: 'blur'
          }
        ],
        sid: [
          {
            required: true,
            message: this.$t('configType.reqSid'),
            trigger: 'blur'
          },
          {
            max: 50,
            message: this.$t('configType.maxLength'),
            trigger: ['blur', 'change']
          }
        ],
        queueId: [
          {
            required: true,
            message: this.$t('configType.reqQueue'),
            trigger: 'blur'
          }
        ],
        i18nKey: [
          {
            max: 50,
            message: this.$t('configType.maxLength'),
            trigger: ['blur', 'change']
          }
        ],
        sort: [{ validator: sortRule, trigger: 'change' }]
      },
      dialogVisible: false,
      eventType: [],
      title: this.$t('configType.addConfig'),
      isUpdate: false
    }
  },
  mounted () {
    this.getQueueList()
    this.getConfigList()
    this.getPushType()
  },
  methods: {
    handlePushTypeChange (value) {
      let single = value.length === 1 ? value : [value[value.length - 1]]
      this.configForm.checkList = single
    },
    getPushType () {
      getByType('pushType')
        .then(data => {
          this.pushTypeList = data.results.results
        })
        .catch(e => console.error('getPushType():', e))
    },
    changePage (current) {
      this.pager.curPage = current
      this.getConfigList()
    },
    changePageSize (pageSize) {
      this.pager.pageSize = pageSize
      this.getConfigList()
    },
    getConfigList () {
      getConfigList({
        params: {},
        pager: this.pager
      })
        .then(data => {
          if (data.code === '00000000') {
            this.tableData = data.payload.results
            this.pager.total = data.payload.totalRecords
          } else {
            this.$message.error(data.message)
          }
        })
        .catch(e => { })
    },
    sumbitConfig () {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          if (this.isUpdate) {
            this.configForm.status = this.configForm.status ? 1 : 0
            updateConfigType(this.configForm)
              .then(data => {
                if (data.code === '00000000') {
                  this.$message.success(this.$t('common.updateSuccess'))
                  this.handleClose()
                  this.getConfigList()
                } else {
                  this.$message.error(data.message)
                }
              })
              .catch(e => console.log(e))
          } else {
            this.configForm.status = this.configForm.status ? 1 : 0
            addConfig(this.configForm)
              .then(data => {
                if (data.code === '00000000') {
                  this.$message.success(this.$t('common.addSuccess'))
                  this.handleClose()
                  this.getConfigList()
                } else {
                  this.$message.error(data.message)
                }
              })
              .catch(e => console.log(e))
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    getQueueList () {
      getQueueLists()
        .then(data => {
          if (data.code === '00000000') {
            this.eventType = data.payload.results.queueList
            if (this.eventType && this.eventType.length > 0) {
              this.configForm.queueId = this.eventType[0].id
            }
          } else {
            this.$message.error(data.message)
          }
        })
        .catch(e => { })
    },
    handleClose () {
      this.dialogVisible = false
      this.configForm.name = ''
      this.configForm.description = ''
      this.configForm.sid = ''
      this.configForm.status = true
      this.configForm.sort = ''
      this.configForm.i18nKey = ''
      this.configForm.queueId = ''
      this.configForm.checkList = []
      this.$refs.ruleForm.resetFields()
    },
    addConfigType () {
      this.dialogVisible = true
      this.title = this.$t('configType.addConfig')
      this.isUpdate = false
      this.configForm.queueId = this.eventType[0].id
    },
    deleteConfig (row) {
      this.$confirm(
        this.$t('configType.deleteConfig'),
        this.$t('common.warningNotice'),
        {
          confirmButtonText: this.$t('common.yes'),
          cancelButtonText: this.$t('common.cancel'),
          type: 'warning'
        }
      )
        .then(() => {
          let params = {
            sid: row.sid
          }
          deleteConfig(params)
            .then(data => {
              if (data.code === '00000000') {
                this.$message({
                  type: 'success',
                  message: this.$t('common.successDelete')
                })
                this.getConfigList()
              } else {
                this.$message.error(data.message)
              }
            })
            .catch(e => { })
        })
        .catch(() => { })
    },
    update (params) {
      this.dialogVisible = true
      this.title = this.$t('configType.updateConfig')
      this.isUpdate = true
      this.configForm.name = params.name
      this.configForm.description = params.description
      this.configForm.sid = params.sid
      this.configForm.status = params.status === 1
      this.configForm.sort = params.sort
      this.configForm.i18nKey = params.i18nKey
      this.configForm.queueId = params.queueId
      this.configForm.id = params.id
      this.configForm.checkList = []
      params.dbsAppSettingPushTypeRef.forEach(item => {
        this.configForm.checkList.push(item.sysDictionaryValue)
      })
    }
  }
}
</script>
<style lang="less" scoped>
@import '~@/styles/var.less';
.tips_cla {
  color: @themeColor;
}
</style>



// WEBPACK FOOTER //
// src/modules/developer/configType.vue